<template>
  <svg
    v-if="iconData"
    viewBox="0 0 24 24"
    v-html="iconData.body" />
</template>

<script lang="ts">
interface ILucideIconData {
  body: string
}

// The full Lucide icon set is large (thousands of icons) — lazy-load it via
// dynamic import so it lands in its own chunk instead of bloating whichever
// chunk first imports this component (used in the Sample Areas side nav).
// Cached at module scope so repeated renders/instances only fetch it once.
let iconsPromise: Promise<Record<string, ILucideIconData>> | null = null
function loadIcons(): Promise<Record<string, ILucideIconData>> {
  if (!iconsPromise) {
    iconsPromise = import('@iconify-json/lucide/icons.json').then(
      (module) => module.default.icons as Record<string, ILucideIconData>
    )
  }
  return iconsPromise
}

export default {
  name: 'DynamicLucideIcon',

  props: {
    name: {
      type: String,
      required: false,
      default: undefined,
    },
  },

  data() {
    return {
      icons: null as Record<string, ILucideIconData> | null,
    }
  },

  computed: {
    iconData(): ILucideIconData | null {
      if (!this.name || !this.icons) return null
      return this.icons[this.name] ?? null
    },
  },

  created() {
    loadIcons().then((icons) => {
      this.icons = icons
    })
  },
}
</script>
